import styled, { css } from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../../BoxSizingStyle";
import { FontStyle } from "../../FontStyle";
import { Body2 } from "../../Typography";

export const StyledOptionGroupLi = styled.li<{ type?: "single" | "multiple" }>`
  flex-direction: column;
  cursor: ${(props) => (props.type === "single" ? "default" : "pointer")};
`;
export const StyledOptionGroup = styled.div`
  ${tw`tw-select-none`}
  ${FontStyle}
  ${BoxSizingStyle}
`;

StyledOptionGroup.displayName = "StyledOptionGroup";

export const StyledOptionGroupHeader = styled.div`
  height: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  margin: 6px 0;
  * {
    margin: auto 0;
  }
`;

StyledOptionGroupHeader.displayName = "StyledOptionGroupHeader";

export const StyledOptionGroupHeaderLabel = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  flex-grow: 1;
`;

StyledOptionGroupHeaderLabel.displayName = "StyledOptionGroupHeaderLabel";

export const StyledOptionGroupIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  flex-shrink: 0;
  color: currentColor;

  svg {
    width: 16px;
    height: 16px;
  }
`;

StyledOptionGroupIcon.displayName = "StyledOptionGroupIcon";

export const StyledOptionGroupHeaderName = styled(Body2)`
  padding-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

StyledOptionGroupHeaderName.displayName = "StyledOptionGroupHeaderName";

export const StyledOptionGroupOption = styled.div<{ hover?: boolean }>`
  ${(props) =>
    props.hover &&
    css`
      background-color: var(--color-theme-200);
    `}
`;

StyledOptionGroupOption.displayName = "StyledOptionGroupOption";
